<template>
  <div class="app_home_container">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "AppHome",
  data() {
    return {
     
    }
  }
};
</script>


<style scoped>
  .app_home_container{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: #f2f2f2;
  }
</style>
